//import $ from 'jquery';
export let cleaveObj = false;

export const cleaveDate = (dateFormat, seperator) => {
	const birthdayInput = $('input[name=U_Birthday]');
		
		if(cleaveObj !== false){
			cleaveObj.destroy();
			birthdayInput.val("");
		}
		cleaveObj= new Cleave(birthdayInput, {
	      date: true,
	      datePattern: dateFormat,
	      delimiters: seperator
	  });

};


export const initCleaveDate = () => {
	const birthdayInput = $('input[name=U_Birthday]');
	const countryDropDown = $('#country');
	if(birthdayInput.length> 0){
		if(countryDropDown.length>0){
			if(countryDropDown.val()== '230'){
				$('input[name=U_Birthday]').closest(".inputGroup").find("label").html("Your Birthday (MM/DD/YYYY)");
				cleaveDate(['m', 'd', 'Y'], ['/','/']);
			}else{
				$('input[name=U_Birthday]').closest(".inputGroup").find("label").html("Your Birthday (DD-MM-YYYY)");
				cleaveDate(['d', 'm', 'Y'],['-','-']);
			}
		}else{
			cleaveDate(['m', 'd', 'Y'],['/','/']);
		}
		//
	}

};
